import { Box, Flex, Image, Text } from "@chakra-ui/react";

const TabElement = ({ index, currentTabIndex, img, children }) => {
    return (
        <Flex direction="column" align="center">
            <Box
                p={{ md: "4", base: "3" }}
                rounded="full"
                shadow="md"
                bg={index === currentTabIndex ? "brand.500" : "white"}
                transitionDuration=".3s"
                _hover={{
                    shadow: "lg",
                }}
            >
                <Image src={img} w={{ md: "8", base: "6" }} alt="ícono" />
            </Box>
            <Text color={index === currentTabIndex ? "accent.500" : "white"} fontSize="sm">
                {children}
            </Text>
        </Flex>
    );
};

export default TabElement;
